<template>
  <v-container id="page-center-list">
    <div class="page-title"> {{$route.name}}</div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="d-flex justify-end" >
        <span>
          <v-select
            v-model="filterItem"
            :items="['센터명','센터주소','센터 전화번호']"
            label=""
            :menu-props="{ auto: true, overflowY: true}"
            outlined dense hide-details
          ></v-select>
        </span>
        <span class="ml-3">
          <v-text-field
            v-model="searchKeyword"
            label="센터 검색"
            append-icon="search"
            dense hide-details
            @click:append="onSearchByKeyword"
            @keyup.enter="onSearchByKeyword"
            maxlength="32"
          ></v-text-field>
        </span>
        <span class="ml-3">
          <c-btn color="blue" outlined @click="centerDialog = true" iconName="add" :disabled="disabledByRole">센터등록</c-btn>
        </span>
      </v-col>
    </v-row>

    <c-table
      :headers="tableHeader"
      :items="centerItem"
     >
      <template #centerAddressInfo="{item}">
        {{item.centerAddress}} {{item.centerAddressDetails}}
      </template>
      <template #status="{item}">
        {{$func.activeStatus(item.status)}}
      </template>
      <template #details="{ item }">
        <c-btn icon iconName="search" @click="onPageRoute(item.id)"/>
      </template>
      <template #login="{ item }">
        <c-btn color="blue" outlined @click="loginSA(item.id)" :disabled="disabledByRole">로그인</c-btn>
      </template>
    </c-table>
    <center-c-u-dialog
      :open.sync="centerDialog"
      @reqAddCenter="reqAddCenter"
    />

    <center-oper-time-c-u-dialog
        :open.sync="timeOpenDialog"
        :center-id="newCenterId"
        @reqAddCenterOperTime="reqAddCenterOperTime"
    ></center-oper-time-c-u-dialog>

    <v-dialog v-model="superAdminCheckDlg" width="300">
      <c-card class="white">
        <div class="py-5 text-center">
          super admin 계정이 없습니다.<br>생성하시겠습니까?
        </div>
        <v-row justify="center" class="mb-4">
          <c-btn class="mr-3" color="blue" @click="addAdmin()">확인</c-btn>
          <c-btn outlined color="grey" @click="superAdminCheckDlg = false">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import CenterCUDialog from "./CenterCUDialog";
  import CenterOperTimeCUDialog from "./CenterOperTimeCUDialog";
  import center from "@/api/center";
  import {setTokenConfig} from "@/api/settiing";
  import routes from "@/router/2u_routes";

  export default {
    components: {CenterCUDialog, CenterOperTimeCUDialog},

    data() {
      return {
        centerDialog: false,
        timeOpenDialog: false,
        superAdminCheckDlg: false,

        newCenterId: '',
        center: '',
        availableId: true,

        tableHeader:[
          {
            text: '센터명',
            value: 'centerName',
            align: 'center',
            sortable: true,
          },
          {
            text: '센터주소',
            value: 'centerAddressInfo',
            align: 'center',
            sortable: true,
          },
          {
            text: '센터 전화번호',
            value: 'number',
            align: 'center',
            sortable: false,
          },
          {
            text: '보유 기사',
            value: 'drivers',
            align: 'center',
            sortable: true,
          },
          {
            text: '보유 차량',
            value: 'vehicles',
            align: 'center',
            sortable: true,
          },
          {
            text: '보유 회원',
            value: 'customers',
            align: 'center',
            sortable: true,
          },
          {
            text: '서비스 이용',
            value: 'status',
            align: 'center',
            sortable: true,
          },
          {
            text: '상세보기',
            value: 'details',
            align: 'center',
            sortable: false,
          },
          {
            text: '로그인',
            value: 'login',
            align: 'center',
            sortable: false,
          },
        ],
        centerItem:[],
        filterItem:'센터명',
        searchKeyword:'',
      }
    },
    activated(){
      this.reqCenterManageInfoList();
    },
    created() {
      if(process.env.VUE_APP_SERVICE !== '2u') {
        this.tableHeader[8].align = ' d-none';
      }
    },
    computed:{
      disabledByRole() {
        return this.$store.state.userInfo.role !== 'SA';
      },
    },
    watch: {
      searchKeyword() {
        if(this.searchKeyword.length < 1) {
          this.reqCenterManageInfoList();
        }
      },
      filterItem() {
        this.searchKeyword = '';
        this.reqCenterManageInfoList();
      }
    },
    methods: {
      async reqCenterManageInfoList() {

        // const res = await this.$api.getCenterManageInfo('SA');
        const res = await this.$api.getCenterManageInfo(this.$store.state.service);
        let result = [];
        for(let i=0 ; i<res.data.length; i++) {
            let data = {};
            data = res.data[i].detailInfo;
            data['admins'] = res.data[i].admins;
            data['customers'] = res.data[i].customers;
            data['drivers'] = res.data[i].drivers;
            data['users'] = res.data[i].users;
            data['vehicles'] = res.data[i].vehicles;
            result.push(data);
        }

        for(let i=0 ; i<result.length; i++) {
          if(result[i].centerName === "아우토크립트" || result[i].centerName === "Autocrypt"){
            result.splice(0, 0, result[i]);
            result.splice(i+1, 1);

          }
          if(result[i].centerName === "이동의자유" || result[i].centerName === "이유_이동의자유") {
            result.splice(1, 0, result[i]);
            result.splice(i+1, 1);
          }
       }

        this.centerItem = result;
      },
      async reqAddCenter(data) {
        try {
          let reqParam = {};
          reqParam = data;
          const res = await this.$api.addCenterInfo(reqParam);
          this.newCenterId = res.data;

          this.centerDialog = false;
          this.timeOpenDialog = true;
          await this.reqCenterManageInfoList();
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqAddCenter'});
          console.error(err)
        }
      },
      onPageRoute(centerId) {
        this.$router.push(`/center/${centerId}`);
      },
      onSearchByKeyword() {

        const tableData = this.centerItem.filter(item => {
          console.log('filter start,' , item);

          if(this.filterItem === '센터명') {
            return item.centerName.indexOf(this.searchKeyword) < 0 ? false : true;
          } else if(this.filterItem === '센터 전화번호') {
            if(item.number === '' || item.number===null) return false;
            else {
              return item.number.split('-').join('').indexOf(this.searchKeyword) < 0 ? false: true;
            }
          } else if(this.filterItem === '센터주소') {
            if(item.centerAddress ==='' || item.centerAddress === null) return false;
            return item.centerAddress.indexOf(this.searchKeyword) < 0 ? false : true;
          }
        });

        this.centerItem = tableData;
        },
        async reqAddCenterOperTime(data) {
          try {
            const res = await this.$api.addCenterOperTime(data);

            this.timeOpenDialog = false;
            this.$store.commit('snackbar', {color: 'blue', msg: '등록이 완료되었습니다.'});
          } catch (err) {
            this.$store.commit('snackbar', {err, where: 'reqAddCenterOperTime'});
          }
        },
       async findSA() {
         const res = await this.$api.getAdminListByRole(this.$store.state.service);
         for (const i in res.data) {
           let admin = res.data[i];
           if(this.center == admin.centerId.id && admin.role == 'SA'){
             return admin;
           }
         }
         return null;
       },
      async loginSA(centerId){
        this.center = centerId;
        const superAdmin = await this.findSA();

        if(superAdmin !== null) {

          const formData = new FormData();
          formData.append('loginId', superAdmin.loginId);
          formData.append('temp', true); //일반로그인과 구분하기위함

          const { data:adminInfo } = await this.$api.login(formData);
          await setTokenConfig(adminInfo.token, adminInfo.refreshToken);

          const { data:roleData } = await this.$api.getUserRouteList();
          const { centerId } = roleData;
          await this.getConfigVal();
          let targetCenter = await this.$api.getCenterInfoById(this.center);
          this.$store.commit('userInfo', {
            loginId: superAdmin.loginId,
            centerId: targetCenter.data.id,
            centerName: targetCenter.data.centerName,
            garagePoint: targetCenter.data.garagePoint,
            centerPoint: targetCenter.data.centerPoint,
            role: adminInfo.role,
            categoryName: roleData.categoryName,
            subRouteName: roleData.subRouteName,
          });

          this.$store.commit('centerInfo', {
            centerId: targetCenter.data.id,
            centerName: targetCenter.data.centerName,
            garagePoint: targetCenter.data.garagePoint,
            centerPoint: targetCenter.data.centerPoint,
            weekday : targetCenter.data.weekday,
            weekdayFirstDrive : targetCenter.data.weekdayFirstDrive,
            weekdayLastDrive : targetCenter.data.weekdayLastDrive,
            weekdayFirstResv : targetCenter.data.weekdayFirstResv,
            weekdayLastResv : targetCenter.data.weekdayLastResv,
            weekend : targetCenter.data.weekend,
            weekendFirstDrive : targetCenter.data.weekendFirstDrive,
            weekendLastDrive : targetCenter.data.weekendLastDrive,
            weekendFirstResv : targetCenter.data.weekendFirstResv,
            weekendLastResv : targetCenter.data.weekendLastResv,
            centerPay : targetCenter.data.centerPay,
            useList : targetCenter.data.useList,
          });

          await location.reload();

        } else {
          this.superAdminCheckDlg = true;
        }
      },
      async getConfigVal() {
        try {
          const res = await this.$api.getConfigVal();

          const data = {...res.data};
          this.$store.commit('config', data);

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'getConfigVal'});
        }
      },
      async addAdmin() {
        this.superAdminCheckDlg = false;
        const admin = await this.$api.getLoginedAdmin();
        let loginId = admin.data.loginId + Math.round(Math.random()*100);

        loginId = await this.idDuplicateCheck(admin, loginId);

        let reqData = {
          centerId: this.center,
          authority: admin.data.role,
          loginId: loginId,
          password: admin.data.password,
          name: admin.data.name,
          extension: admin.data.extension,
          menuRole: admin.data.menuRole
        };

        try {
          const res = await this.$api.addAdmin(reqData);
          this.$store.commit('snackbar', {color: 'blue', msg: '계정이 추가되었습니다.'});
          await this.loginSA(this.center);
        } catch (err) {
          console.log(err);
          this.$store.commit('snackbar', {color: 'red', msg: '계정 생성에 실패했습니다. 잠시 후 다시 시도해 주세요.'});
          this.superAdminCheckDlg = false;
        }
      },
      async idDuplicateCheck(admin, loginId){
        let SALoginId = loginId;

        while (true){
          const res = await this.$api.getCenterAdmin(SALoginId, this.center, 'SA');
          this.availableId = !!!(res.data);

          if (this.availableId) {
            break;
          } else {
            SALoginId = admin.data.loginId + Math.round(Math.random()*100);
            continue;
          }
        }
        return SALoginId;
      },
    }
  }
</script>

<style scoped>

</style>
